module.exports = __webpack_public_path__ + "static/img/festival05.517a594.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/festival05.jpg
// module id = 283
// module chunks = 0